$component-class: 'sn-versions-table';

table,
thead,
tbody,
tfoot,
tr,
th,
td {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  border-collapse: collapse;
  border-spacing: 0;
  vertical-align: top;
  text-align: left;
  font-weight: normal;
}

.#{$component-class} {
  display: block;
  background-color: $background-color-primary;

  &__container {
    // Match the signnow me-container width so this lines up with the
    // me-container-based blocks on the page ($media-desktop (1440) was too wide).
    max-width: $sn-container-max-width;
    margin: 0 auto;
    padding: 0 $spacing-xl $spacing-5xl;

    @include desktop {
      padding: 0 $spacing-3xl $spacing-6xl;
    }

    @include desktop-lg {
      padding-top: 0;
      padding-bottom: $spacing-7xl;
    }
  }

  &__intro {
    text-align: center;
    margin-bottom: $spacing-3xl;

    @include desktop {
      margin-bottom: $spacing-4xl;
    }
  }

  &__title {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1.2;
    color: $text-color-primary;
    margin: 0 0 $spacing-lg;

    @include desktop {
      font-size: 2.5rem;
    }
  }

  &__subtitle {
    font-size: 1rem;
    line-height: 1.6;
    color: $text-color-tertiary;
    margin: 0 auto;
    max-width: 640px;
  }

  &__table-wrap {
    width: 100%;
    overflow-x: auto;
  }

  &__table {
    width: 100%;
    min-width: 435px;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
  }

  &__header-row {
    border-bottom: $border-size-sm solid $border-color-secondary;
  }

  &__header-cell {
    width: 33.333%;
    padding: $spacing-sm $spacing-xl;
    font-weight: 700;
    font-size: 0.9375rem;
    color: $text-color-primary;
    border-bottom: $border-size-sm solid $border-color-secondary;

    &--versions {
      text-align: left;
    }

    &--popularity {
      text-align: center;
    }

    &--fillable {
      text-align: center;
    }
  }

  &__row {
    &--highlighted {
      td {
        background-color: $background-color-brand-primary-lightest;
        border-top: $border-size-sm solid $border-color-brand-primary;
        border-bottom: $border-size-sm solid $border-color-brand-primary;

        &:first-child {
          border-left: $border-size-sm solid $border-color-brand-primary;
          border-radius: $radius-size-md 0 0 $radius-size-md;
        }

        &:last-child {
          border-right: $border-size-sm solid $border-color-brand-primary;
          border-radius: 0 $radius-size-md $radius-size-md 0;
        }
      }
    }
  }

  &__cell {
    width: 33.333%;
    min-width: 145px;
    padding: $spacing-md $spacing-xl;
    vertical-align: middle;
    font-size: 0.9375rem;

    &--popularity {
      text-align: center;
      color: var(--text-color-tertiary, #{$text-color-tertiary});
    }

    &--fillable {
      text-align: center;
    }
  }

  &__link {
    color: var(--color-brand-primary-dark, #{$link-color-brand-primary});
    text-decoration: none;
    font-weight: 600;

    &:hover {
      color: var(--color-brand-primary-darker, #{$action-color-brand-primary-hover});
      text-decoration: underline;
    }
  }

  // WCAG AA on the highlighted row (#e8f2fa), measured on production:
  //   link  #0777cf → 4.07:1, hover #348fd7 → 3.06:1, rating #667988 → 3.98:1 — all under the
  //   4.5:1 floor for this 15px text. The palette already carries the fixed steps:
  //   primary-dark #076dbd → 4.71:1, primary-darker #065797 → 6.57:1, tertiary #546470 → 5.39:1.
  // The declarations above cannot deliver them on their own: the deployed global stylesheet
  // ships rules for the same two elements at the same (0,1,0) specificity and later in the
  // cascade, so it wins (verified against production — a (0,1,0) override changed nothing while
  // a `[data-color-mode]`-prefixed one took effect). Matching the theme attribute lifts these to
  // (0,2,0) so the accessible colours actually apply.
  [data-color-mode] &__cell--popularity {
    color: var(--text-color-tertiary, #{$text-color-tertiary});
  }

  [data-color-mode] &__link {
    color: var(--color-brand-primary-dark, #{$link-color-brand-primary});

    &:hover {
      color: var(--color-brand-primary-darker, #{$action-color-brand-primary-hover});
    }
  }

  &__check {
    color: $text-color-success;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
  }
}
